import { render, staticRenderFns } from "./project.vue.html?vue&type=template&id=08d4be48&"
import script from "./project.ts?vue&type=script&lang=ts&"
export * from "./project.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports